// Local helpers to track anonymous purchases via the user's browser.
// Each Stripe session_id is stored after a successful payment.
const KEY = "gai_purchases_v1";

export function getPurchases() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function addPurchase(sessionId) {
  if (!sessionId) return;
  const list = new Set(getPurchases());
  list.add(sessionId);
  localStorage.setItem(KEY, JSON.stringify([...list]));
}

export function purchasesQueryParam() {
  const ids = getPurchases();
  return ids.length ? ids.join(",") : "";
}
